
export class AllEvaluationMethodsResponse {
  methodName: string;
  evaluationMethodId: number;
  notAppliedEvaluationMethodId: number;
  srcDiscussion: string;
  destDiscussion: string;
  srcUsed?: boolean;
  destUsed?: boolean;
  mnaCollapsed?: boolean;
  srcDiscussionCollapsed?: boolean;
  destDiscussionCollapsed?: boolean;
  srcMethodNameExists?: boolean;
  destMethodNameExists?: boolean;
}
